import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import { InfluencerService } from "../services/influencer.service";

export default function useRequestSocialMediaProfileAIAnalysis() {
  const {
    mutate: requestProfileAnalysis,
    isLoading: isRequestProfileAnalysisLoading,
    isSuccess: isRequestProfileAnalysisSuccess,
    error: requestProfileAnalysisError,
  } = useMutation<string, BackednResponse<string>>({
    mutationFn: (socialMediaObjectId: string) =>
      InfluencerService.requestProfileAnalysis(socialMediaObjectId),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, "social-media-v2", params],
      });
    },
  });

  return {
    requestProfileAnalysis,
    isRequestProfileAnalysisLoading,
    isRequestProfileAnalysisSuccess,
    requestProfileAnalysisError,
  };
}
